/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandPopularItemsEnabled} from '../api'

export const useMutationSetBrandPopularItemsEnabled = createReactQueryMutationHook('setBrandPopularItemsEnabled', setBrandPopularItemsEnabled)
